import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const Section = styled.section`
  padding: 96px 0;
  background: var(--nd-surface);
`;

const SectionLabel = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin: 0 0 16px;
`;

const SectionTitle = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 36px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  margin: 0 0 8px;
`;

const Lede = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  max-width: 560px;
  margin: 0 0 48px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const Item = styled.div`
  border-left: 2px solid var(--nd-accent);
  padding: 4px 0 4px 16px;
`;

const Title = styled.div`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: var(--nd-text-display);
  margin: 0 0 4px;
`;

const Desc = styled.div`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
`;

const ITEMS = [
  {
    t: "Frontend / product code",
    d: "We don't touch your React app, your Rails monolith, your iOS build. We stop at the infra layer.",
  },
  {
    t: "Project management for non-DevOps work",
    d: "We won't own your roadmap or run your sprint planning. We show up to standups, we don't run them.",
  },
  {
    t: "On-site",
    d: "We're remote. We can fly in for a kickoff or a quarterly if you cover it, but we don't bill T&E by default.",
  },
  {
    t: "Lock-in tooling",
    d: "If we install something, you can rip it out. Standard open-source where possible. No proprietary glue you can't replace.",
  },
];

const WhatWeDontDo = () => (
  <Section>
    <Container>
      <SectionLabel>What we don't do</SectionLabel>
      <SectionTitle>The boundaries are part of the offer.</SectionTitle>
      <Lede>
        Saying no to the work outside our circle of competence is how we stay good
        at the work inside it.
      </Lede>
      <Grid>
        {ITEMS.map((it) => (
          <Item key={it.t}>
            <Title>{it.t}</Title>
            <Desc>{it.d}</Desc>
          </Item>
        ))}
      </Grid>
    </Container>
  </Section>
);
export default WhatWeDontDo;
